
import { NgModule } from 'ng-metadata/core';

// Components
import { StickyHeaderDirective } from './sticky-header.directive';

/**
 * @ngdoc module
 * @name mw.components.stickyHeader
 * @description
 *
 *
 */
@NgModule({
    declarations: [
        StickyHeaderDirective
    ]
})
export class StickyHeaderModule {}



// WEBPACK FOOTER //
// ./src/lib/components/sticky-header/sticky-header.module.ts